module.exports = "<gw-currency-input on-blur=\"applyNewValue\" initial-value=\"item().getValue()\" int=\"true\" currency=\"{{currency}}\"></gw-currency-input>"